import React from 'react';

import { makeComponentMap } from '@netfront/common-library';

import { QuestionAnswerCalendarSnippet } from './QuestionAnswerCalendarSnippet';
import { QuestionAnswerCheckboxSnippet } from './QuestionAnswerCheckboxSnippet';
import { QuestionAnswerDropDownListSnippet } from './QuestionAnswerDropDownListSnippet';
import { QuestionAnswerMatchSnippet } from './QuestionAnswerMatchSnippet';
import { QuestionAnswerMultiLineTextSnippet } from './QuestionAnswerMultiLineTextSnippet';
import { QuestionAnswerMultiResponseTextSnippet } from './QuestionAnswerMultiResponseTextSnippet';
import { QuestionAnswerNumberSnippet } from './QuestionAnswerNumberSnippet';
import { QuestionAnswerRadioSnippet } from './QuestionAnswerRadioSnippet';
import { QuestionAnswerRangeInputSnippet } from './QuestionAnswerRangeInputSnippet';
import { QuestionAnswerSingleLineTextSnippet } from './QuestionAnswerSingleLineTextSnippet';
import { QuestionSnippetProps } from './QuestionSnippet.interfaces';

import { getContentSnippet, useContentPageContext } from '../../../contexts';
import { DOMPurifySanitizedHtmlContent } from '../../DOMPurifySanitizedHtmlContent';

const getComponentByType = makeComponentMap({
  Calendar: QuestionAnswerCalendarSnippet,
  Checkbox: QuestionAnswerCheckboxSnippet,
  DropDownList: QuestionAnswerDropDownListSnippet,
  Match: QuestionAnswerMatchSnippet,
  MultiResponseText: QuestionAnswerMultiResponseTextSnippet,
  MultiText: QuestionAnswerMultiLineTextSnippet,
  Number: QuestionAnswerNumberSnippet,
  Radio: QuestionAnswerRadioSnippet,
  SingleText: QuestionAnswerSingleLineTextSnippet,
  Slider: QuestionAnswerRangeInputSnippet,
});

const QuestionSnippet = ({
  accessToken,
  contentSnippetId,
  contentSnippetQuestion,
  formType = 'LIST',
  summaryFeedbackConfiguration,
  summaryFeedbackMode,
  userFlowStepTrackId,
  response,
}: QuestionSnippetProps) => {
  const { state: contentPage } = useContentPageContext();

  const contentSnippet = contentSnippetQuestion ?? getContentSnippet(contentSnippetId, contentPage);

  const { configuration, majorNumber, questionText = '', visible: isVisible } = contentSnippet ?? {};
  const { __typename: questionConfigurationTypeName } = configuration ?? {};

  const describedById = `question-snippet-id-${contentSnippetId}`;
  const questionContent = majorNumber ? `<span class="c-question-snippet__major">${majorNumber}</span>${questionText}` : questionText;

  const Component = getComponentByType(questionConfigurationTypeName);

  return (
    <div className="c-question-snippet">
      {isVisible && questionText && (
        <React.Fragment>
          {formType !== 'TABLE' && (
            <div className="c-question-snippet__question" id={describedById}>
              <DOMPurifySanitizedHtmlContent html={questionContent} />
            </div>
          )}

          <Component
            accessToken={accessToken}
            contentSnippetId={contentSnippetId}
            contentSnippetQuestion={contentSnippetQuestion}
            response={response}
            summaryFeedbackConfiguration={summaryFeedbackConfiguration}
            summaryFeedbackMode={summaryFeedbackMode}
            userFlowStepTrackId={userFlowStepTrackId}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export { QuestionSnippet };
